import { List } from 'immutable';

import { effects } from './effects';
import { trackingMiddleware } from './middleware';
import * as segmentSelectors from './segment/selectors';
import * as selectors from './selectors';
import { analyticsActionCreators, analyticsState } from './state';
import { identifyOnStartup, trackCollectedActions } from './subscriber';
import { IActionTransformFilter } from './types';

import { exportModule } from './module';

type IAnalyticsModuleParams = { trackableActions: string[]; actionHandlers?: IActionTransformFilter[] };

const BaseAnalyticsModule = exportModule<IAnalyticsModuleParams, any, any>({
  state: List.of(analyticsState),
  effects,
  subscribers: List.of(
    identifyOnStartup(selectors.isReady, segmentSelectors.selectTrackingInitializationEffectCreator),
    trackCollectedActions(
      selectors.isReady,
      segmentSelectors.getActionsToTrack,
      analyticsActionCreators.clear,
      segmentSelectors.trackWithState
    )
  ),
  combine: (mod, params) => {
    const initialCollectedParams: IAnalyticsModuleParams = { trackableActions: [], actionHandlers: [] };
    return mod.update('middleware', (middleware) =>
      middleware.push(
        trackingMiddleware(
          params.reduce(
            (collectedParams, param) => ({
              trackableActions: collectedParams.trackableActions.concat(param.trackableActions),
              actionHandlers: collectedParams.actionHandlers.concat(param.actionHandlers || [])
            }),
            initialCollectedParams
          )
        )
      )
    );
  }
});

export const AnalyticsModule = (params: IAnalyticsModuleParams) => BaseAnalyticsModule.set('params', params);
export * from './segment/effects';
